// extracted by mini-css-extract-plugin
module.exports = {"main":"alpha-banner-styles_main__3i4Z1"};